import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivationEnd, NavigationEnd } from '@angular/router';

@Component({
  selector: 'div[id=tma-app-root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit {
  @ViewChild("focusElement") focusElement!: ElementRef;
  
  title = 'tracmyair';
  ariaLiveMessage = '';
  
  constructor(
    private router: Router
  ) { }
  
  ngAfterViewInit(): void {
    this.router.events.subscribe(data => {
      if (data instanceof ActivationEnd) {
        this.ariaLiveMessage = `The current page is ${data.snapshot.data['livePage']}.`;
      }
      if (data instanceof NavigationEnd) {
        this.focusElement.nativeElement.focus();
      }
    });
  }
}
